// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"rP-z","categoryName":"sP-z","categoryNameSearchHeader":"tP-z","categoryContent":"uP-z","bottomAligned":"vP-z","image":"wP-z","imageNoBackground":"xP-z"};